import gql from 'graphql-tag';

import { executeGqlQuery, type GqlQueryOptions } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendCustomer, BackendQueryCustomerArgs } from 'src/types/backend';

import { CUSTOMER_FULL_FRAGMENT, CUSTOMER_PAYMENT_METHOD_FRAGMENT } from './schema';

const QUERY = gql`
  query Customer($id: ID!, $includePaymentMethod: Boolean!) {
    customer(id: $id) {
      ...CustomerFull

      paymentMethod @include(if: $includePaymentMethod) {
        ...CustomerPaymentMethod
      }
    }
  }
  ${CUSTOMER_FULL_FRAGMENT}
  ${CUSTOMER_PAYMENT_METHOD_FRAGMENT}
`;

type Variables = {
  id: BackendQueryCustomerArgs['id'];
  includePaymentMethod?: boolean;
};
type Result = BackendCustomer;

export const queryCustomer = async (
  variables: Variables,
  options?: Pick<GqlQueryOptions, 'abortSignal'>
) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
    options: {
      abortSignal: options?.abortSignal,
    },
  });

  return getSingleProp<Result>(result.data);
};
